export class AdditionalDto {
    public addSelected?: string;
    public baseAmount?: number;

    constructor(addSelected = null, baseAmount = 0){
        this.addSelected=addSelected;
        this.baseAmount=baseAmount;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/additional/additional-dto.ts